/**
 * 部门KPI设置API服务
 */
import api from './api/client';

// 类型定义
export interface KPIDimension {
    id: number;
    name: string;
    code: string;
    description: string;
    is_higher_better: boolean;
    max_score: number;
    is_active: boolean;
    category?: string;
    category_display?: string;
}

export interface PerformancePeriod {
    id: number;
    name: string;
    period_type: string;
    start_date: string;
    end_date: string;
    status: string;
}

export interface DepartmentKPIProfile {
    id: number;
    department: number;
    department_name: string;
    period: number;
    period_name: string;
    kpi1: number | null;
    kpi1_name: string | null;
    kpi1_code: string | null;
    kpi1_weight: number;
    kpi2: number | null;
    kpi2_name: string | null;
    kpi2_code: string | null;
    kpi2_weight: number;
    kpi3: number | null;
    kpi3_name: string | null;
    kpi3_code: string | null;
    kpi3_weight: number;
    kpi4: number | null;
    kpi4_name: string | null;
    kpi4_code: string | null;
    kpi4_weight: number;
    attitude_weight: number;
    total_weight: number;
    is_active: boolean;
}

export interface DepartmentKPITarget {
    id: number;
    department: number;
    department_name: string;
    period: number;
    period_name: string;
    dimension: number;
    dimension_name: string;
    dimension_code: string;
    target_value: number;
    remarks: string;
}

export interface Department {
    id: number;
    name: string;
}

// API 方法
export const kpiSettingsAPI = {
    // KPI 指标
    getDimensions: () => api.get<KPIDimension[]>('/kpi-dimensions/'),

    // 考核周期
    getPeriods: () => api.get<PerformancePeriod[]>('/performance-periods/'),

    // 部门
    getDepartments: () => api.get<{ results: Department[] }>('/departments/'),

    // 部门KPI配置
    getProfiles: (periodId?: number) => {
        const params = periodId ? { period_id: periodId } : {};
        return api.get<DepartmentKPIProfile[]>('/dept-kpi-profiles/', { params });
    },

    getProfilesByPeriod: (periodId: number) =>
        api.get<DepartmentKPIProfile[]>('/dept-kpi-profiles/by_period/', { params: { period_id: periodId } }),

    saveProfile: (data: Partial<DepartmentKPIProfile>) =>
        api.post('/dept-kpi-profiles/', data),

    updateProfile: (id: number, data: Partial<DepartmentKPIProfile>) =>
        api.put(`/dept-kpi-profiles/${id}/`, data),

    batchSaveProfiles: (profiles: any[]) =>
        api.post('/dept-kpi-profiles/batch_save/', { profiles }),

    copyFromPeriod: (fromPeriodId: number, toPeriodId: number) =>
        api.post('/dept-kpi-profiles/copy_from_period/', { from_period_id: fromPeriodId, to_period_id: toPeriodId }),

    // 部门目标值
    getTargets: (departmentId?: number, periodId?: number) => {
        const params: any = {};
        if (departmentId) params.department_id = departmentId;
        if (periodId) params.period_id = periodId;
        return api.get<DepartmentKPITarget[]>('/dept-kpi-targets/', { params });
    },

    getTargetsByDeptPeriod: (departmentId: number, periodId: number) =>
        api.get<DepartmentKPITarget[]>('/dept-kpi-targets/by_dept_period/', {
            params: { department_id: departmentId, period_id: periodId }
        }),

    batchSaveTargets: (departmentId: number, periodId: number, targets: any[]) =>
        api.post('/dept-kpi-targets/batch_save/', {
            department_id: departmentId,
            period_id: periodId,
            targets
        }),
};

export default kpiSettingsAPI;
